module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated fadeIn",
    class: {
      'is-active': _vm.active
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card animated fadeInUp"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [(_vm.dismiss !== false) ? _c('span', {
    staticClass: "close close-modal",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.Events.$emit('closeAlertModal')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('img', {
    attrs: {
      "src": "/images/sad.png"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.body))])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot push-top-small"
  }, _vm._l((_vm.actions), function(value) {
    return _c('button', {
      staticClass: "button is-primary is-large",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.Events.$emit('alertModalDone', value)
        }
      }
    }, [_vm._v(_vm._s(value))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cea1dac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/alert-modal.vue
// module id = 546
// module chunks = 0